<template>
    <div class="warpper">
        <div class="page-title">意见反馈</div>
        <div class="flex flex-direction align-center">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto"
                     class="ruleForm margin-top-xs" v-loading="loading">
                <el-form-item ref="phone" label="联系电话" prop="phone" class="input-container">
                    <el-input v-model="ruleForm.phone" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item ref="content" label="反馈内容" prop="content" class="input-container">
                    <el-input v-model="ruleForm.content" placeholder="请输入"
                              type="textarea" :autosize="{ minRows: 5, maxRows: 5 }" resize="none"></el-input>
                </el-form-item>
            </el-form>
            <el-button class="input-form-btn margin-tb-sm self-center" type="warning"
                       @click="submitForm('ruleForm')" :loading="submit_loading">
                提交反馈
            </el-button>
        </div>
    </div>
</template>

<script>
    import rules from "@/utils/rules";
    import {TOAST, toast} from "@/utils/utils";
    import {feedback} from "@/api/organiz";
    export default {
        name: "feedback",
        data() {
            return {
                ruleForm: {
                    phone: '',//
                    content: '',//
                },
                rules: {
                    phone: [
                        {required: true, message: '请输入联系电话', trigger: 'blur'},
                        rules.phone
                    ],
                    content: [
                        {required: true, message: '请输入反馈内容', trigger: 'blur'},
                    ]
                },
                loading: false,
                submit_loading: false,
            }
        },
        created() {
            this.$emit('setIndex', [10,1], '意见反馈')
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.submitChange();
                    } else {
                        return false;
                    }
                });
            },
            async submitChange(){
                this.submit_loading = true
                let _data = await feedback(
                    this.ruleForm.phone,
                    this.ruleForm.content,
                )
                this.submit_loading = false
                if (_data.status === 200) {
                    toast('提交成功')
                    this.$refs.ruleForm.resetFields()
                } else {
                    toast(_data.msg, TOAST.error)
                }
            }
        }

    }
</script>

<style scoped lang="scss">
    .warpper {
        padding: 20px 30px;
        background-color: #ffffff;
        border-radius: 10px;
        .ruleForm{
            width: 605px;
            margin-top: 94px;
            .input-form-title{
                font-size: 28px;
                font-weight: bold;
                color: #262626;
                margin-bottom: 36px;
            }
            .input-container {
                color: #262626;
                font-weight: bold;
            }
            .input-form-btn{
                width: 200px;
                height: 40px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#0a2240, #0a2240);
                background-blend-mode: normal, normal;
                border-radius: 20px;
                font-size: 16px;
                color: #ffffff;
            }
        }
        .forget{
            font-size: 16px;
            color: #0a2240;
            span{
                color: #69a3dc;
            }
        }
    }
</style>